<template>
    <layout-gestao v-cloak>
        <div class="row">
            <div class="col-sm-12">
                <form
                    autocomplete="off"
                    method="post"
                    :disabled="isLoading"
                    data-vv-scope="form"
                    @keyup.enter="() => {}">
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                            <h1 class="content-title">{{ titleItem }}</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-7">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-title"
                                    name="title"
                                    v-model.trim="form.title"
                                    v-validate="'required|max:100'"
                                    :inputClasses="[{'is-invalid': fnHasError(`title`) }]"
                                    :error=" fnFirstError(`title`)"
                                    :helpText="`${pageID}.help.title`">
                                    {{ $t(`${pageID}.model.title`) }}
                                </MaterialInput>
                            </div>
                        </div>
                        <div class="col-12 col-md-5">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-type"
                                    label="title"
                                    name="type"
                                    :options="lists.types"
                                    :reduce="option => option.id"
                                    v-model.trim="form.type_id"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('type') }]"
                                    :error="fnFirstError('type')"
                                    :helpText="`${pageID}.help.type`">
                                    {{ $t(`${pageID}.model.type`) }}
                                </MaterialSelect>
                            </div>
                        </div>

                        <div class="col-12 col-md-5">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-published"
                                    label="name"
                                    name="published"
                                    :options="lists.onoff"
                                    :reduce="option => option.code"
                                    v-model.trim="form.published"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('published') }]"
                                    :error="fnFirstError('published')"
                                    :helpText="`${pageID}.help.published`" >
                                    {{ $t(`${pageID}.model.published`) }}
                                </MaterialSelect>
                            </div>
                        </div>
                        <div class="col-12 col-md-5">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-footer"
                                    label="name"
                                    name="footer"
                                    :options="lists.onoff"
                                    :reduce="option => option.code"
                                    v-model.trim="form.on_footer"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('footer') }]"
                                    :error="fnFirstError('footer')"
                                    :helpText="`${pageID}.help.footer`" >
                                    {{ $t(`${pageID}.model.footer`) }}
                                </MaterialSelect>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <MaterialInput
									:readonly="readonlyFormItem"
									type="number"
									class="city-form-group city-bg"
									id="input-order"
									name="order"
									v-model.trim="form.order"
									v-validate="'required|integer|min_value:1'"
									:inputClasses="[{'is-invalid': fnHasError('order') }]"
									:error=" fnFirstError('order')">
									{{ $t(`${pageID}.model.order`) }}
								</MaterialInput>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="form-group">
                                <label class="city-label">{{ $t(`${pageID}.model.content`) }}</label>
                                <div class="city-form-group" :class="{'is-invalid': fnHasError('content') }">
                                    <ckeditor
                                        name="content"
                                        v-model="form.content"
                                        :disabled="readonlyFormItem"
                                        :editor="cKEditor.editor"
                                        :config="cKEditor.editorConfig"
                                        v-validate="'min:50'"
                                    />
                                    <small v-if="fnFirstError('content')" class="d-block invalid-feedback">{{ fnFirstError('content') }}</small>
                                    <help-span :helpText="`${pageID}.help.content`"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-redirect"
                                    name="redirect"
                                    v-model.trim="form.redirect"
                                    v-validate="urlValidation"
                                    :inputClasses="[{'is-invalid': fnHasError(`redirect`) }]"
                                    :error=" fnFirstError(`redirect`)"
                                    :helpText="`${pageID}.help.url`">
                                    {{ $t(`${pageID}.model.url`) }}
                                </MaterialInput>
                            </div>
                        </div>
                    </div>
                    <buttons-footer
                        :enableButtons="!readonlyFormItem"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="isDisabled"
                        @save="saveItem"
                        @cancel="handleBack(`${moduleCode}.${pageID}`)"
                    />
                </form>
            </div>
        </div>
    </layout-gestao>
</template>

<script>
    import mixin from '../../mixin';
    import CkEditorConfigMixin from '@/app/shared/mixins/ckeditor/BaseCkEditorConfigMixin';

    export default {
        mixins: [
            mixin,
            CkEditorConfigMixin,
        ],
        components: {
            HelpSpan: () => import(/* webpackChunkName: "help-span" */ '@/components/form/HelpSpan'),
        },
        data() {
            return {
                pageID: 'pages',
                form: {
                    id: null,
                    name: null,
                    slug: null,
                    content: '',
                    type_id: null,
                    published: true,
                    redirect: null,
                    on_footer: false,
                    order: 1,
                },
                lists: {
                    loaded: false,
                    types: [],
                    onoff: [{'id': 1, 'name': 'Sim', 'code': true}, {'id': 2, 'name': 'Não', 'code': false}],
                },
            }
        },
        mounted() {
            this.loadLists();
        },
        computed: {
            urlValidation() {
                return {
                    // relative or absolute URL
                    regex: /^(https?:\/\/|\/)\w+\.[^\s]+$|^\/[^\s]*$/
                }
            }
        },
        methods: {
            loadLists() {
                if (!this.lists.loaded && this.url.getTypes) {
                    this.$http.get(this.url.getTypes)
                    .then(res => {
                        let data = res.data ? res.data : res;
                        this.lists.types = data.data;
                        this.lists.loaded = true;
                    })
                    .catch(error => {
                        this.lists.loaded = false;
                        this.showHttpError(error);
                    });
                }
            },
            // onBeforeSaveItem() {
            //     if(this.isLoading) return;
            //         if(!this.form.layer_id) {
            //         for ( var key in this.form ) {
            //             if(['id', 'title', 'content', 'redirect', 'type_id', 'published'].includes(key)){
            //                 continue;
            //             }
            //             this.form[key] = null;
            //         }
            //     }
            //     this.saveItem();
            // },
        },
        watch: {
            'form.content': function( val ) {
                if(val === null) {
                    this.form.content = '';
                }
            },
        }
    }
</script>
